<template>
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs
        :active-name="activeName"
        type="card"
        style="width: 100%;"
      >
        <el-tab-pane name="tabenglishDescriptionOfGoods" :label="$t('Information.EnglishProductName')" :lazy="true">
          <tab-sensitive-config :word-field="1" />
        </el-tab-pane>
        <el-tab-pane name="tabChineseDescriptionOfGoods" :label="$t('Information.ChineseProductName')" :lazy="true">
          <tab-sensitive-config :word-field="0" />
        </el-tab-pane>
        <el-tab-pane name="tabMark" :label="$t('Information.MarksAndNumbers')" :lazy="true">
          <tab-sensitive-config :word-field="2" />
        </el-tab-pane>
        <el-tab-pane name="tabShipper" :label="$t('Information.mailing')" :lazy="true">
          <tab-sensitive-config :word-field="3" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import tabSensitiveConfig from '@/views/cargo/v0/Information/components/sensitiveWord/tabSensitiveConfig'

export default {
  name: 'SensitiveWord',
  components: { tabSensitiveConfig },
  data() {
    return {
      activeName: 'tabenglishDescriptionOfGoods'
    }
  },
  watch: {
    activeName(newVal) {
      if (newVal) {
        this.loadTab(newVal)
      }
    }
  },
  mounted() {
    this.loadTab(this.activeName)
  },
  methods: {
    loadTab(activeName) {
      const tabRef = this.refs[activeName]
      if (tabRef && tabRef.onShow) {
        tabRef.onShow()
      }
    }
  }
}
</script>

<style scoped>

</style>
